import React, { useEffect, useRef, useState } from 'react'
import ContainerButton from '../../../components/button/ContainerButton'
import { routeName } from '../../../routes/routeName'
import NavigateListCustom from '../../../components/navigation/NavigationListCustom'
import ContainerLayout from '../../../components/container-layout/ContainerLayout'
import { useTranslation } from 'react-i18next'
import { Box, Checkbox, Divider, FormControlLabel, FormGroup, Grid, IconButton, Typography } from '@mui/material'
import StepperCustom from '../../../components/step/Stepper'
import StateComponents from '../../../components/state-component/StateComponents'
import { handleTypingNumber } from '../../../utils/app.utils'
import { EducationTypeApi } from '../../../api/education-type/education_type'
import { CourseOfStudyApi } from '../../../api/course-of-study/course-of-study.api'
import moment from 'moment'
import { DistrictApi } from '../../../api/district/district.api'
import { ProvinceAPI } from '../../../api/province/province.api'
import { SubDistrictApi } from '../../../api/sub-district/sub-district.api'
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice'
import { AdmissionFrontApi } from '../../../api/admission-front/admission-front.api'
import { alertError, alertSuccess, swalError } from '../../../components/alert/swal'
import { DocumentsApi } from '../../../api/documents/documents.api'
import AddBoxIcon from '@mui/icons-material/AddBox';
import OptionsButtonCustom from '../../../components/option-button/OptionsButtonCustom'
import { ButtonContained } from '../../../components/button/ButtonCustoms'
import CancelIcon from '@mui/icons-material/Cancel';
import { timeToView } from '../../../utils/date.utils'
import HtmlRenderer from '../../../components/render-html/RenderHtml'
import { CountryApi } from '../../../api/country/country.api'
export default function AdmissionForm() {
    const { t } = useTranslation();
    const { id } = useParams()
    const dispatch = useDispatch();
    const navigate: NavigateFunction = useNavigate();
    const [tabStep, setTebStep] = useState(0);
    const [form, setForm] = useState<any>({
        admission_student: {
            title: "",
            first_name: "",
            middle_name: "",
            last_name: "",
            nickname: "",
            phone: "",
            email: "",
            id_education_type: 0,
            education_type_name: "",
            name_of_institue: "",
            year_graduated: "",
            gpa: 0,
            dhamma_qualification: "",
            english_qualification: "",
            idcard: "",
            date_of_issue: "",
            date_of_expiry: "",
            id_degree: 0,
            id_faculty: 0,
            id_academic_year: 0,
            id_course_of_study: 0,
            weight: 0,
            height: 0,
            blood: "",
            date_of_birth: "",
            place_of_birth: "",
            race: "",
            nationality: "",
            religion: "",
            occupation: "",
            ordination_date: "",
            sect: "",
            dissability: "",
            number_of_sibling: 0,
            number_of_sibling_still_study: 0,
            skill: "",
            step: "0"
        },
        admission_student_address: [{
            address_type: 'HOUSE_REGISTRATION_ADDRESS',
            name_of_temple: '',
            name_of_abbot: '',
            house_no: '',
            street: '',
            village: '',
            town: '',
            province: '',
            district: '',
            district_sub: '',
            country: '',
            postcode: '',
        },
        {
            address_type: 'CURRENT_ADDRESS',
            name_of_temple: '',
            name_of_abbot: '',
            house_no: '',
            street: '',
            village: '',
            town: '',
            province: '',
            district: '',
            district_sub: '',
            country: '',
            postcode: '',
        }],
        admission_student_parent: {
            father_name: "",
            father_status: "",
            father_occupation: "",
            father_income: "",
            mother_name: "",
            mother_status: "",
            mother_occupation: "",
            mother_income: "",
            parent_marriage: "",
            refperson_name: "",
            refperson_relationship: "",
            refperson_occupation: "",
            refperson_income: "",
            refperson_house: "",
            refperson_street: "",
            refperson_vilage: "",
            refperson_town: "",
            refperson_district: "",
            refperson_province: "",
            refperson_district_sub: "",
            refperson_country: "",
            refperson_postcode: "",
            refperson_phone: "",
            refperson_email: ""
        },
        admission_student_file: [],
        // admission_student_register_payment: {
        //     id_admission_student_register_payment: 0,
        //     payment_date: "",
        //     payment_currency: "",
        //     payment_amount: 0,
        //     payment_type: ""
        // }
    })
    const allStep = [
        {
            name: "",
            isAccept: false,
            icon: null
        },
        {
            name: "",
            isAccept: false,
            icon: null
        },
        {
            name: "",
            isAccept: false,
            icon: null
        },
        {
            name: "",
            isAccept: false,
            icon: null
        },
        {
            name: "",
            isAccept: false,
            icon: null
        },
        {
            name: "",
            isAccept: false,
            icon: null
        },

    ];
    // console.log(form);

    const getDetail = async () => {
        dispatch(setLoading());

        await AdmissionFrontApi.findOne(id).then((res) => {
            if (res.status < 300) {
                setForm({
                    ...res.data.data,
                    admission_student: res.data.data,
                    admission_student_file: res.data.data?.admission_student_files,
                    admission_student_register_payment: {
                        ...res.data.data?.admission_student_register_payment,
                        payment_file: res.data.data?.admission_student_register_payment,
                        payment_date_time: res.data.data?.admission_student_register_payment?.payment_date ? timeToView(res.data.data?.admission_student_register_payment?.payment_date) : ''
                    }
                })


                setTebStep(+res.data.data?.step)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    useEffect(() => {
        if (id) {
            getDetail()
        }
    }, [id])

    const handleSubmit = async (type?: any, tab?: any) => {
        if (!form?.admission_student?.id_academic_year) {
            return alertError('Specify Academic Year')
        }
        if (!form?.admission_student?.id_degree) {
            return alertError('Specify Degree')
        }
        if (!form?.admission_student?.id_faculty) {
            return alertError('Specify Faculty')
        }

        const body = {
            ...form,
            admission_student: {
                ...form?.admission_student,
                step: tab
            },
            admission_student_register_payment: form?.admission_student_register_payment?.payment_date ? {
                ...form?.admission_student_register_payment,
                payment_date: `${moment(form?.admission_student_register_payment?.payment_date).format('YYYY-MM-DD')}T${form?.admission_student_register_payment?.payment_date_time}`,
                payment_type: 'ATTACH_SLIP'
            } : undefined
        }
        dispatch(setLoading());
        if (id) {
            await AdmissionFrontApi.patch(+id, body)
                .then((res) => {
                    if (res.status < 300) {
                        if (type !== 'SENT') {
                            if (type === 'NEXT') {
                                getDetail()
                            } else {
                                getDetail()
                                alertSuccess("Save Draft", "succeed")
                            }

                        } else {
                            handleSent()
                        }
                        // navigate(routeName.admission.ManagePayment)
                    }
                })
                .catch((err) => {
                    console.log(err);
                    alertError("Save Draft", err?.response?.data?.message || "Error");
                })
                .finally(() => {
                    dispatch(unsetLoading());
                });
        } else {
            await AdmissionFrontApi.post(body)
                .then((res) => {
                    if (res.status < 300) {
                        if (res.data.data.id_admission_student) {
                            if (type === 'NEXT') {
                                getDetail()
                                navigate(routeName.admission.AdmissionFormUpdte?.replace(':id', res.data.data?.id_admission_student))

                            } else {
                                getDetail()
                                navigate(routeName.admission.AdmissionFormUpdte?.replace(':id', res.data.data?.id_admission_student))
                                alertSuccess("Save Draft", "succeed")
                            }
                        }


                    }
                })
                .catch((err) => {
                    console.log(err);
                    alertError("Save Draft", err?.response?.data?.message || "Error");
                })
                .finally(() => {
                    dispatch(unsetLoading());
                });
        }

    }
    const handleSent = async () => {
        dispatch(setLoading());
        if (id) {
            await AdmissionFrontApi.sent(+id)
                .then((res) => {
                    if (res.status < 300) {
                        alertSuccess("IBSC Online Admission", "succeed")
                        navigate(routeName.admission.HistoryOnlineAdmission)
                    }
                })
                .catch((err) => {
                    console.log(err);
                    alertError("IBSC Online Admission", err?.response?.data?.message || "Error");
                })
                .finally(() => {
                    dispatch(unsetLoading());
                });
        }
    }
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("IBSC Online Admission Form")}
                hidden_sub_title
                navigateContent={
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "complaintSubmit",
                                name: t("IBSC Online Admission"),
                                pathName: routeName.admission.IBSCOnlineAdmission
                            },
                            {
                                key: "complaintSubmit",
                                name: t("IBSC Online Admission Form"),
                                pathName: routeName.admission.AdmissionForm
                            },
                        ]}
                    />
                }

                content={
                    <div className='w-full'>
                        <section
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                marginTop: "24px",
                            }}
                        >
                            <StepperCustom
                                step={tabStep}
                                setStep={setTebStep}
                                stepLabel={allStep}
                                sx={{
                                    width: '600px'
                                }}
                            />
                        </section>
                        {tabStep === 0 && <AdmissionStudent form={form} setForm={setForm} />}
                        {tabStep === 1 && <AdmissionStudentOther form={form} setForm={setForm} />}
                        {tabStep === 2 && <AdmissionStudentAddress form={form} setForm={setForm} />}
                        {tabStep === 3 && <AdmissionStudentParent form={form} setForm={setForm} />}
                        {tabStep === 4 && <Documents form={form} setForm={setForm} />}
                        {tabStep === 5 && <AdmissionStudentRegisterPayment form={form} setForm={setForm} />}
                        <ContainerButton
                            sxContainer={{ my: 3 }}
                            buttonData={[
                                {
                                    seq: 1,
                                    buttonProps: {
                                        onClick: () => { },
                                    },
                                    key: "CANCEL",
                                    label: "Cancel",
                                    type: "CANCEL"
                                },

                                {
                                    seq: 2,
                                    buttonProps: {
                                        onClick: () => {
                                            handleSubmit()
                                        },
                                    },
                                    key: "SAVE_DRAFT",
                                    label: "Save Draft",
                                    type: 'SAVE_DRAFT'
                                },
                                {
                                    seq: 3,
                                    buttonProps: {
                                        onClick: () => {
                                            setTebStep(tabStep + 1)
                                            setForm({ ...form, admission_student: { ...form?.admission_student, step: +tabStep + 1 } })
                                            handleSubmit('NEXT', +tabStep + 1)

                                        },
                                    },
                                    hidden: tabStep === 5,
                                    key: "NONE",
                                    label: "Next",
                                    type: "NONE"
                                },
                                {
                                    seq: 3,
                                    buttonProps: {
                                        onClick: () => {
                                            // setTebStep(tabStep + 1)
                                            // setForm({ ...form, admission_student: { ...form?.admission_student, step: tabStep + 1 } })
                                            handleSubmit('SENT')
                                            // handleSent()
                                        },
                                    },
                                    hidden: tabStep !== 5,
                                    key: "CONFIRM",
                                    label: "Confirm",
                                    type: 'CONFIRM'
                                },
                            ]}
                        />
                    </div>
                }
            />

        </div>
    )
}

const AdmissionStudent = (props: any) => {
    const { form, setForm } = props
    const [educationType, setEducationType] = useState<any[]>([])
    const [academicYear, setAcademicYear] = useState<any[]>([])
    const [degree, setDegree] = useState<any[]>([])
    const [faculty, setFaculty] = useState<any[]>([])
    const getEducationType = async () => {
        await EducationTypeApi.list().then((res) => {
            if (res.status < 300) {
                setEducationType(res.data || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const getAcademicYear = async () => {
        let query = {

        }
        if (form.admission_student?.id_academic_year) query = { ...query, id_academic_year: form.admission_student?.id_academic_year }
        if (form.admission_student?.id_degree) query = { ...query, id_degree: form.admission_student?.id_degree }

        await CourseOfStudyApi.academicDataDropdown(query).then((res) => {
            if (res.status < 300) {
                const uniqueAcademicYears = res.data.data.reduce((acc: any[], curr: any) => {
                    if (!acc.some(item => item.academic_year === curr.academic_year)) {
                        acc.push({
                            id_academic_year: curr.id_academic_year, // ถ้า null ให้เป็น 5
                            academic_year: curr.academic_year,
                        });
                    }
                    return acc;
                }, []);

                setAcademicYear(uniqueAcademicYears || []);
                const uniqueDegree = res.data.data.reduce((acc: any[], curr: any) => {
                    if (!acc.some(item => item.id_degree === curr.id_degree)) {
                        acc.push({
                            id_degree: curr.id_degree, // ถ้า null ให้เป็น 5
                            degree_name: curr.degree_name,
                            degree_name_eng: curr.degree_name_eng,
                        });
                    }
                    return acc;
                }, []);

                setDegree(uniqueDegree || []);
                setFaculty(res.data.data || []);

            }
        }).catch((err) => {
            console.log(err)
        })
    }
    // const getDegree = async () => {
    //     let query: any = {
    //         id_academic_year: undefined
    //     }
    //     if (form?.admission_student?.id_academic_year) query = { ...query, id_academic_year: form?.admission_student?.id_academic_year }
    //     await CourseOfStudyApi.academicDataDropdown(query).then((res) => {
    //         if (res.status < 300) {
    //             const uniqueDegree = res.data.data.reduce((acc: any[], curr: any) => {
    //                 if (!acc.some(item => item.id_degree === curr.id_degree)) {
    //                     acc.push({
    //                         id_degree: curr.id_degree, // ถ้า null ให้เป็น 5
    //                         degree_name: curr.degree_name,
    //                         degree_name_eng: curr.degree_name_eng,
    //                     });
    //                 }
    //                 return acc;
    //             }, []);

    //             setDegree(uniqueDegree || []);
    //         }
    //     }).catch((err) => {
    //         console.log(err)
    //     })
    // }
    // const getFaculty = async () => {
    //     let query: any = {
    //         id_academic_year: undefined
    //     }
    //     if (form?.admission_student?.id_degree) query = { ...query, id_degree: form?.admission_student?.id_degree }
    //     await CourseOfStudyApi.academicDataDropdown(query).then((res) => {
    //         if (res.status < 300) {

    //             setFaculty(res.data.data || []);
    //         }
    //     }).catch((err) => {
    //         console.log(err)
    //     })
    // }
    // useEffect(() => {
    //     getDegree()
    // }, [form?.admission_student?.id_academic_year])
    // useEffect(() => {
    //     getFaculty()
    // }, [form?.admission_student?.id_degree])
    useEffect(() => {
        getAcademicYear()
    }, [form.admission_student?.id_academic_year, form.admission_student?.id_degree])
    useEffect(() => {
        getEducationType()
    }, [])


    const text = `<p>
    This is an Online Application Form which is originated from the IBSC form 2 for Furthering Education in International Buddhist Studies College (IBSC), 
Mahachulalongkornrajavidyalaya University.

Noted :
1. It’s would be best if you submit your CV and check your English qualification to meet the English language requirement.
2. You are guaranteed that the qualification and details stated in this application form are all truth; and if theuniversity proves later that I am lack of any 
    qualification, I am pleased to comply with every rule and regulation of theuniversity in the relevant part.
3. Please fill in your details below.
Please upload your documents in the last session of the form
- Official Photo (size 1.5 inches) 
- Passport(for foreigner) / ID card(for Thai)
- Transcript & Certificate 
- Medical certificate
- Covid-19 Vaccination Certificate
- House Registration (For Thai)
- Monk’s identification card(for Thai)
- English language Requirement (Except Certi. MM. ) 
- CV / Resume (For MA & PhD)
- Certificate of Dhamma Studies 
- Certificate of Personal Name Change
    </p>`
    return (
        <>
            <Box>
                {text ? <HtmlRenderer html={text} /> : <></>}
            </Box>
            <StateComponents
                otherProps={{ spacing: 2 }}
                typeProps={
                    [
                        {
                            seq: 1,
                            type: "SELECT",
                            gridProps: {
                                xs: 12,
                                md: 2
                            },
                            fieldProps: {
                                labelId: "ss",
                                heading: "Title",
                                onChange: (e) => {
                                    // handleChange('form_type', index, e.target.value);
                                    setForm({ ...form, admission_student: { ...form?.admission_student, title: e.target.value } })
                                },
                                options: [
                                    {
                                        label: "Mr.",
                                        value: 'Mr.',
                                    },
                                    {
                                        label: "Ms.",
                                        value: 'Ms.',
                                    },

                                ],
                                selectId: "",
                                value: form?.admission_student?.title
                            }
                        },
                        {
                            seq: 2,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 5
                            },
                            fieldProps: {
                                heading: "Name",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, first_name: e.target.value } })
                                },
                                value: form?.admission_student?.first_name

                            }
                        },
                        {
                            seq: 3,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 5
                            },
                            fieldProps: {
                                heading: "Last Name",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, last_name: e.target.value } })
                                },
                                value: form?.admission_student?.last_name
                            }
                        },
                        {
                            seq: 4,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 6
                            },
                            fieldProps: {
                                heading: "Middle-Name or Buddhist Name (If doesn't have just leave it blank)",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, middle_name: e.target.value } })
                                },
                                value: form?.admission_student?.middle_name
                            }
                        },
                        {
                            seq: 5,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                heading: "Phone Number",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, phone: e.target.value } })
                                },
                                value: form?.admission_student?.phone,
                                onkeypress: handleTypingNumber,

                            }
                        },
                        {
                            seq: 6,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                heading: "E-mail",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, email: e.target.value } })
                                },
                                value: form?.admission_student?.email,
                            }
                        },
                        {
                            type: "COMPONENT",
                            seq: 7,
                            fieldProps: {
                                element: <Divider />
                            },
                            gridProps: {
                                xs: 12,
                            }
                        },
                        {
                            seq: 8,
                            type: "SELECT",
                            gridProps: {
                                xs: 12,
                                md: 6
                            },
                            fieldProps: {
                                labelId: "ss",
                                heading: "Educational level",
                                onChange: (e) => {
                                    // handleChange('form_type', index, e.target.value);
                                    setForm({ ...form, admission_student: { ...form?.admission_student, id_education_type: e.target.value, education_type_name: educationType?.find((item: any) => item?.id_education_type === e.target.value)?.education_type_name } })
                                },
                                options: educationType?.map((item: any) => {
                                    return {
                                        label: item?.education_type_name,
                                        value: item?.id_education_type,
                                    }
                                }),
                                selectId: "",
                                value: form?.admission_student?.id_education_type
                            }
                        },
                        // {
                        //     seq: 8,
                        //     type: "TEXT_FIELD",
                        //     gridProps: {
                        //         xs: 12,
                        //         md: 6
                        //     },
                        //     fieldProps: {
                        //         heading: "Educational level",
                        //         onChange: (e) => { }
                        //     }
                        // },
                        {
                            seq: 9,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 6
                            },
                            fieldProps: {
                                heading: "Name of the Institute",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, name_of_institue: e.target.value } })
                                },
                                value: form?.admission_student?.name_of_institue,
                            }
                        },
                        {
                            seq: 10,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 6
                            },
                            fieldProps: {
                                heading: "Year of graduated",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, year_graduated: e.target.value } })
                                },
                                value: form?.admission_student?.year_graduated,
                                onkeypress: handleTypingNumber,
                            }
                        },
                        {
                            seq: 11,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 6
                            },
                            fieldProps: {
                                heading: "GPA",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, gpa: e.target.value } })
                                },
                                value: form?.admission_student?.gpa,
                                onkeypress: handleTypingNumber,
                            }
                        },
                        {
                            seq: 12,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 6
                            },
                            fieldProps: {
                                heading: "My Dhamma Qualifications",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, dhamma_qualification: e.target.value } })
                                },
                                value: form?.admission_student?.dhamma_qualification,
                            }
                        },
                        {
                            seq: 13,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 6
                            },
                            fieldProps: {
                                heading: "English Qualification",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, english_qualification: e.target.value } })
                                },
                                value: form?.admission_student?.english_qualification,
                            }
                        },
                        {
                            type: "COMPONENT",
                            seq: 14,
                            fieldProps: {
                                element: <Typography>Apply For :</Typography>
                            },
                            gridProps: {
                                xs: 12,
                            }
                        },
                        {
                            seq: 15,
                            type: "SELECT",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                labelId: "ss",
                                heading: "Academic Year",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, id_academic_year: e.target.value } })
                                },
                                options: academicYear.map((item: any) => {
                                    return {
                                        label: item?.academic_year,
                                        value: item?.id_academic_year,
                                    }
                                }),
                                selectId: "",
                                value: form?.admission_student?.id_academic_year,
                            }
                        },
                        {
                            seq: 16,
                            type: "SELECT",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                labelId: "ss",
                                heading: "Degree",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, id_degree: e.target.value } })
                                },
                                options: degree.map((item: any) => {
                                    return {
                                        label: `${item?.degree_name_eng} (${item?.degree_name})`,
                                        value: item?.id_degree,
                                    }
                                }),
                                selectId: "",
                                value: form?.admission_student?.id_degree,
                            }
                        },
                        {
                            seq: 17,
                            type: "SELECT",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                labelId: "ss",
                                heading: "Major",
                                onChange: (e) => {
                                    setForm({
                                        ...form,
                                        admission_student: { ...form?.admission_student, id_faculty: e.target.value, id_course_of_study: faculty?.find((item: any) => item?.id_faculty === e.target.value)?.id_course_of_study },
                                        // admission_student_register_payment: {
                                        //     // id_admission_student_register_payment: faculty?.find((item: any) => item?.id_faculty === e.target.value)?.register_id_payment_channels,
                                        //     payment_date: "",
                                        //     payment_currency: "THB",
                                        //     payment_amount: 0,
                                        //     payment_type: "ATTACH_SLIP"
                                        // },
                                        payment_channels: faculty?.find((item: any) => item?.id_faculty === e.target.value)
                                    })
                                    // setForm({
                                    //     ...form,
                                    //     admission_student_register_payment: {
                                    //         // id_admission_student_register_payment: faculty?.find((item: any) => item?.id_faculty === e.target.value)?.register_id_payment_channels,
                                    //         payment_date: "2025-08-21T09:24:35.983Z",
                                    //         payment_currency: "THB",
                                    //         payment_amount: 2000,
                                    //         payment_type: "ATTACH_SLIP"
                                    //     },

                                    // })
                                },
                                options: faculty.map((item: any) => {
                                    return {
                                        label: `${item?.faculty_name_eng} (${item?.faculty_name})`,
                                        value: item?.id_faculty,
                                    }
                                }),
                                selectId: "",
                                value: form?.admission_student?.id_faculty,
                            }
                        },
                    ]} />
        </>

    )
}
const AdmissionStudentOther = (props: any) => {
    const { form, setForm } = props

    return (
        <>
            <Typography variant='h4'>Personal Information</Typography>
            <StateComponents
                otherProps={{ spacing: 2 }}
                sxContainer={{ marginTop: '10px' }}
                typeProps={
                    [
                        {
                            seq: 19,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Passport number (Foreigner)/ID Card Number (Thai)",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, idcard: e.target.value } })
                                },
                                value: form?.admission_student?.idcard,
                                // onkeypress: handleTypingNumber
                            }
                        },

                        {
                            seq: 20,
                            type: "DATE",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, date_of_issue: moment(e).format('YYYY-MM-DD') } })
                                },
                                heading: '(Passport) Date of issue',
                                placeholder: '(Passport) Date of issue',
                                allowClear: true,
                                onClear: () => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, date_of_issue: '' } })
                                },
                                value: form?.admission_student?.date_of_issue,
                            }
                        },
                        {
                            seq: 21,
                            type: "DATE",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, date_of_expiry: moment(e).format('YYYY-MM-DD') } })
                                },
                                heading: '(Passport) Date of expiry',
                                placeholder: '(Passport) Date of expiry',
                                allowClear: true,
                                onClear: () => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, date_of_expiry: '' } })
                                },
                                value: form?.admission_student?.date_of_expiry,

                            }
                        },
                        {
                            seq: 22,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 1
                            },
                            fieldProps: {
                                heading: "Weight (kg.)",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, weight: e.target.value } })
                                },
                                value: form?.admission_student?.weight,
                                onkeypress: handleTypingNumber
                            }
                        },
                        {
                            seq: 23,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 1
                            },
                            fieldProps: {
                                heading: "Height (cm.)",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, height: e.target.value } })
                                },
                                value: form?.admission_student?.height,
                                onkeypress: handleTypingNumber
                            }
                        },
                        {
                            seq: 24,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 1
                            },
                            fieldProps: {
                                heading: "Blood Type",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, blood: e.target.value } })
                                },
                                value: form?.admission_student?.blood,
                            }
                        },
                        {
                            seq: 25,
                            type: "DATE",
                            gridProps: {
                                xs: 12,
                                md: 2
                            },
                            fieldProps: {
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, date_of_birth: moment(e).format('YYYY-MM-DD') } })
                                },
                                heading: 'Date of Birth',
                                placeholder: 'Date of Birth',
                                allowClear: true,
                                onClear: () => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, date_of_birth: '' } })
                                },
                                value: form?.admission_student?.date_of_birth,
                            }

                        },
                        {
                            seq: 26,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 5
                            },
                            fieldProps: {
                                heading: "Place of Birth",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, place_of_birth: e.target.value } })
                                },
                                value: form?.admission_student?.place_of_birth,
                            }
                        },
                        {
                            seq: 27,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 2
                            },
                            fieldProps: {
                                heading: "Race/Ethnic",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, race: e.target.value } })
                                },
                                value: form?.admission_student?.race,
                            }
                        },
                        {
                            seq: 28,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Nationality",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, nationality: e.target.value } })
                                },
                                value: form?.admission_student?.nationality,
                            }
                        },
                        {
                            seq: 29,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Religion",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, religion: e.target.value } })
                                },
                                value: form?.admission_student?.religion,
                            }
                        },
                        {
                            seq: 30,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Occupation",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, occupation: e.target.value } })
                                },
                                value: form?.admission_student?.occupation,
                            }
                        },
                        {
                            seq: 31,
                            type: "DATE",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, ordination_date: moment(e).format('YYYY-MM-DD') } })
                                },
                                heading: 'Date of Ordination (laypeople please skip this )',
                                placeholder: 'Date of Ordination (laypeople please skip this )',
                                allowClear: true,
                                onClear: () => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, ordination_date: '' } })
                                },
                                value: form?.admission_student?.ordination_date,
                            }

                        },
                        {
                            seq: 32,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Sect (laypeople please skip this )",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, sect: e.target.value } })
                                },
                                value: form?.admission_student?.sect,
                            }
                        },
                        {
                            seq: 33,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Disability",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, dissability: e.target.value } })
                                },
                                value: form?.admission_student?.dissability,
                            }
                        },
                        {
                            seq: 34,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Number of sibling",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, number_of_sibling: e.target.value } })
                                },
                                value: form?.admission_student?.number_of_sibling,
                                onkeypress: handleTypingNumber
                            }
                        },
                        {
                            seq: 35,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Number of sibling whom still study",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, number_of_sibling_still_study: e.target.value } })
                                },
                                value: form?.admission_student?.number_of_sibling_still_study,
                                onkeypress: handleTypingNumber
                            }
                        },
                        {
                            seq: 36,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Skills/Interests",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student: { ...form?.admission_student, skill: e.target.value } })
                                },
                                value: form?.admission_student?.skill,
                            }
                        },
                    ]} />
        </>

    )
}
const AdmissionStudentAddress = (props: any) => {
    const { form, setForm } = props
    const [country_data, setCountryData] = useState<any[]>([]);
    // const [province_data, setProVinceData] = useState<any[]>([]);
    // const [district_data, setDistrictData] = useState<any[]>([]);
    // const [sub_district_data, setSubDistrictData] = useState<any[]>([]);

    const handleGetCountry = async () => {
        let query: any = {
            page: 1,
            limit: 10000
        }
        await CountryApi.list(query).then(res => {
            if (res.status < 300) {
                setCountryData(res.data?.data.items || [])
            } else {
                setCountryData([]);
            }
        }).catch((error) => console.log(error))
    }
    // const handleGetProvince = async () => {
    //     await ProvinceAPI.GetProvince().then(res => {
    //         if (res.status < 300) {
    //             setProVinceData(res.data?.data || [])
    //         } else {
    //             setProVinceData([]);
    //         }
    //     }).catch((error) => console.log(error))
    // }
    // const handleGetDistrict = async (id?: any) => {
    //     if (id) {
    //         await DistrictApi.getDistrictByProvince(id).then(res => {
    //             if (res.status < 300) {
    //                 setDistrictData(res.data?.data || [])
    //             } else {
    //                 setDistrictData([]);
    //             }
    //         }).catch((error) => console.log(error))
    //     } else {
    //         // await DistrictApi.getAllDistrict().then(res => {
    //         //     if (res.status < 300) {
    //         //         setDistrictData(res.data?.data || [])
    //         //     } else {
    //         //         setDistrictData([]);
    //         //     }
    //         // }).catch((error) => console.log(error))
    //     }

    // }
    // const handleGetSubDistrict = async (id?: any) => {
    //     if (id) {
    //         await SubDistrictApi.getSubDistrictByDistrict(id).then(res => {
    //             if (res.status < 300) {
    //                 setSubDistrictData(res.data?.data || [])
    //             } else {
    //                 setSubDistrictData([]);
    //             }
    //         }).catch((error) => console.log(error))
    //     } else {
    //         // await SubDistrictApi.getAllSubDistrict().then(res => {
    //         //     if (res.status < 300) {
    //         //         setSubDistrictData(res.data?.data || [])
    //         //     } else {
    //         //         setSubDistrictData([]);
    //         //     }
    //         // }).catch((error) => console.log(error))
    //     }

    // }


    useEffect(() => {
        // handleGetProvince()
        // handleGetDistrict()
        // handleGetSubDistrict()
        handleGetCountry()
    }, [])
    return (
        <>
            <Typography variant='h4'>Address</Typography>
            <StateComponents
                otherProps={{ spacing: 2 }}
                sxContainer={{ marginTop: '10px' }}
                typeProps={
                    [
                        {
                            seq: 39,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 6
                            },
                            fieldProps: {
                                heading: "Name of the Temple (laypeople please skip this section)",
                                onChange: (e) => {
                                    const current = form?.admission_student_address.find((x: any) => x.address_type === 'CURRENT_ADDRESS')
                                    const house = form?.admission_student_address.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')
                                    setForm({ ...form, admission_student_address: [{ ...current }, { ...house, name_of_temple: e.target.value }] })
                                },
                                value: form?.admission_student_address?.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.name_of_temple
                            }
                        },
                        {
                            seq: 40,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 6
                            },
                            fieldProps: {
                                heading: "Name of the Abbot (laypeople please skip this section)",
                                onChange: (e) => {
                                    const current = form?.admission_student_address.find((x: any) => x.address_type === 'CURRENT_ADDRESS')
                                    const house = form?.admission_student_address.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')
                                    setForm({ ...form, admission_student_address: [{ ...current }, { ...house, name_of_abbot: e.target.value }] })
                                },
                                value: form?.admission_student_address?.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.name_of_abbot
                            }
                        },
                        {
                            seq: 41,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "House No.",
                                onChange: (e) => {
                                    const current = form?.admission_student_address.find((x: any) => x.address_type === 'CURRENT_ADDRESS')
                                    const house = form?.admission_student_address.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')
                                    setForm({ ...form, admission_student_address: [{ ...current }, { ...house, house_no: e.target.value }] })
                                },
                                value: form?.admission_student_address?.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.house_no
                            }
                        },
                        {
                            seq: 42,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Street / Road",
                                onChange: (e) => {
                                    const current = form?.admission_student_address.find((x: any) => x.address_type === 'CURRENT_ADDRESS')
                                    const house = form?.admission_student_address.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')
                                    setForm({ ...form, admission_student_address: [{ ...current }, { ...house, street: e.target.value }] })
                                },
                                value: form?.admission_student_address?.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.street

                            }
                        },
                        {
                            seq: 43,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Village",
                                onChange: (e) => {
                                    const current = form?.admission_student_address.find((x: any) => x.address_type === 'CURRENT_ADDRESS')
                                    const house = form?.admission_student_address.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')
                                    setForm({ ...form, admission_student_address: [{ ...current }, { ...house, village: e.target.value }] })
                                },
                                value: form?.admission_student_address?.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.village
                            }
                        },
                        {
                            seq: 44,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Town / City",
                                onChange: (e) => {
                                    const current = form?.admission_student_address.find((x: any) => x.address_type === 'CURRENT_ADDRESS')
                                    const house = form?.admission_student_address.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')
                                    setForm({ ...form, admission_student_address: [{ ...current }, { ...house, town: e.target.value }] })
                                },
                                value: form?.admission_student_address?.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.town
                            }
                        },
                        // {
                        //     seq: 45,
                        //     type: "TEXT_FIELD",
                        //     gridProps: {
                        //         xs: 12,
                        //         md: 4
                        //     },
                        //     fieldProps: {
                        //         heading: "District",
                        //         onChange: (e) => { }
                        //     }
                        // },
                        // {
                        //     seq: 45,
                        //     type: "TEXT_FIELD",
                        //     gridProps: {
                        //         xs: 12,
                        //         md: 4
                        //     },
                        //     fieldProps: {
                        //         heading: "Province",
                        //         onChange: (e) => { }
                        //     }
                        // },
                        {
                            seq: 45,
                            // type: "AUTO-COMPLETE",
                            // gridProps: {
                            //     xs: 12,
                            //     md: 4
                            // },
                            // fieldProps: {
                            //     getOptionLabel: (op: any) => op?.province_name,
                            //     labelId: "select_position",
                            //     placeholder: "Province",
                            //     heading: "Province",
                            //     onChange: (_: any, value: any) => {

                            //         if (value) {
                            //             // setForm({ ...form, province: value?.province_name })
                            //             setForm({ ...form, admission_student_address: { ...form?.admission_student_address, province: value?.province_name, district: '' } })

                            //             handleGetDistrict(value?.id_province)

                            //         } else {
                            //             // setForm({ ...form, province: undefined })
                            //             setForm({ ...form, admission_student_address: { ...form?.admission_student_address, province: '', district: '' } })

                            //             setDistrictData([])
                            //         }
                            //     },
                            //     options: province_data || [],
                            //     value: province_data?.find((x) => x?.province_name === form?.admission_student_address?.province) || null
                            // }
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Province",
                                onChange: (e) => {
                                    const current = form?.admission_student_address.find((x: any) => x.address_type === 'CURRENT_ADDRESS')
                                    const house = form?.admission_student_address.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')
                                    setForm({ ...form, admission_student_address: [{ ...current }, { ...house, province: e.target.value }] })
                                },
                                value: form?.admission_student_address?.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.province
                            }
                        },
                        {
                            seq: 46,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "District",
                                onChange: (e) => {
                                    const current = form?.admission_student_address.find((x: any) => x.address_type === 'CURRENT_ADDRESS')
                                    const house = form?.admission_student_address.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')
                                    setForm({ ...form, admission_student_address: [{ ...current }, { ...house, district: e.target.value }] })
                                },
                                value: form?.admission_student_address?.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.district
                            }
                            // type: "AUTO-COMPLETE",
                            // gridProps: {
                            //     xs: 12,
                            //     md: 4
                            // },
                            // fieldProps: {
                            //     getOptionLabel: (op: any) => op?.district_name,
                            //     labelId: "select_position",
                            //     placeholder: "District",
                            //     heading: "District",
                            //     onChange: (_: any, value: any) => {

                            //         if (value) {
                            //             // setForm({ ...form, district: value?.district_name })
                            //             setForm({ ...form, admission_student_address: { ...form?.admission_student_address, district: value?.district_name, district_sub: '' } })

                            //             handleGetSubDistrict(value?.id_district)

                            //         } else {
                            //             // setForm({ ...form, district: undefined })
                            //             setForm({ ...form, admission_student_address: { ...form?.admission_student_address, district: '', district_sub: '' } })

                            //             setSubDistrictData([])
                            //         }
                            //     },
                            //     options: district_data || [],
                            //     value: district_data?.find((x) => x?.district_name === form?.admission_student_address?.district) || null,
                            //     inputValue: form?.admission_student_address?.district || '',
                            // }
                        },
                        {
                            seq: 47,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "State",
                                onChange: (e) => {
                                    const current = form?.admission_student_address.find((x: any) => x.address_type === 'CURRENT_ADDRESS')
                                    const house = form?.admission_student_address.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')
                                    setForm({ ...form, admission_student_address: [{ ...current }, { ...house, district_sub: e.target.value }] })
                                },
                                value: form?.admission_student_address?.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.district_sub
                            }
                            // type: "AUTO-COMPLETE",
                            // gridProps: {
                            //     xs: 12,
                            //     md: 4
                            // },
                            // fieldProps: {
                            //     getOptionLabel: (op: any) => op?.district_sub_name,
                            //     labelId: "select_position",
                            //     placeholder: "State",
                            //     heading: "State",
                            //     onChange: (_: any, value: any) => {

                            //         if (value) {
                            //             console.log(value);
                            //             // setForm({ ...form, district_sub: value?.sub_district_name })
                            //             setForm({ ...form, admission_student_address: { ...form?.admission_student_address, district_sub: value?.district_sub_name } })


                            //         } else {
                            //             // setForm({ ...form, district_sub: undefined })
                            //             setForm({ ...form, admission_student_address: { ...form?.admission_student_address, district_sub: '' } })

                            //         }
                            //     },
                            //     options: sub_district_data || [],
                            //     value: sub_district_data?.find((x) => x?.sub_district_name === form?.admission_student_address?.district_sub) || null,
                            //     inputValue: form?.admission_student_address?.district_sub || '',

                            // }
                        },
                        // {
                        //     seq: 47,
                        //     type: "TEXT_FIELD",
                        //     gridProps: {
                        //         xs: 12,
                        //         md: 4
                        //     },
                        //     fieldProps: {
                        //         heading: "State",
                        //          onChange: (e) => {
                        //             setForm({ ...form, admission_student_address: { ...form?.admission_student_address, first_name: e.target.value } })
                        //         },
                        //         value: form?.admission_student_address?.first_name
                        //     }
                        // },
                        {
                            seq: 48,
                            type: "AUTO-COMPLETE",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                getOptionLabel: (op: any) => op?.country_name,
                                labelId: "select_position",
                                placeholder: "Country",
                                heading: "Country",
                                onChange: (_: any, value: any) => {
                                    const current = form?.admission_student_address.find((x: any) => x.address_type === 'CURRENT_ADDRESS')
                                    const house = form?.admission_student_address.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')
                                    if (value) {
                                        // setForm({ ...form, district_sub: value?.sub_district_name })

                                        setForm({ ...form, admission_student_address: [{ ...current }, { ...house, country: value?.country_name }] })
                                        // setForm({ ...form, admission_student_address: { ...form?.admission_student_address, country: value?.country_name } })


                                    } else {
                                        // setForm({ ...form, district_sub: undefined })
                                        setForm({ ...form, admission_student_address: [{ ...current }, { ...house, country: '' }] })

                                        // setForm({ ...form, admission_student_address: { ...form?.admission_student_address, country: '' } })

                                    }
                                },
                                options: country_data || [],
                                value: country_data?.find((x) => x?.country_name === form?.admission_student_address?.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.country) || null,
                                inputValue: form?.admission_student_address?.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.country || '',

                            }
                        },
                        // {
                        //     seq: 48,
                        //     type: "TEXT_FIELD",
                        //     gridProps: {
                        //         xs: 12,
                        //         md: 4
                        //     },
                        //     fieldProps: {
                        //         heading: "Country",
                        //         onChange: (e) => {
                        //             setForm({ ...form, admission_student_address: { ...form?.admission_student_address, country: e.target.value } })
                        //         },
                        //         value: form?.admission_student_address?.country
                        //     }
                        // },
                        {
                            seq: 49,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Postal/Zip Code",
                                onChange: (e) => {
                                    const current = form?.admission_student_address.find((x: any) => x.address_type === 'CURRENT_ADDRESS')
                                    const house = form?.admission_student_address.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')
                                    setForm({ ...form, admission_student_address: [{ ...current }, { ...house, postcode: e.target.value }] })
                                },
                                value: form?.admission_student_address?.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.postcode,
                                onkeypress: handleTypingNumber
                            }
                        },
                    ]} />
            <Typography variant='h4' sx={{ marginTop: '20px' }}>Current Address</Typography>
            <FormControlLabel control={<Checkbox onChange={(e) => {
                const current = form?.admission_student_address.find((x: any) => x.address_type === 'CURRENT_ADDRESS')
                const house = form?.admission_student_address.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')
                if (e.target.checked) {

                    setForm({ ...form, admission_student_address: [{ ...house }, { ...house, address_type: 'CURRENT_ADDRESS' }] })
                } else {
                    setForm({
                        ...form, admission_student_address: [{ ...house }, {
                            address_type: 'CURRENT_ADDRESS',
                            name_of_temple: '',
                            name_of_abbot: '',
                            house_no: '',
                            street: '',
                            village: '',
                            town: '',
                            province: '',
                            district: '',
                            district_sub: '',
                            country: '',
                            postcode: '',
                        }]
                    })

                }
            }} />} label="Use the same address as above." />
            <StateComponents
                otherProps={{ spacing: 2 }}
                sxContainer={{ marginTop: '10px' }}
                typeProps={
                    [
                        {
                            seq: 39,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 6
                            },
                            fieldProps: {
                                heading: "Name of the Temple (laypeople please skip this section)",
                                onChange: (e) => {
                                    const current = form?.admission_student_address.find((x: any) => x.address_type === 'CURRENT_ADDRESS')
                                    const house = form?.admission_student_address.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')
                                    setForm({ ...form, admission_student_address: [{ ...house }, { ...current, name_of_temple: e.target.value }] })
                                },
                                value: form?.admission_student_address?.find((x: any) => x.address_type === 'CURRENT_ADDRESS')?.name_of_temple
                            }
                        },
                        {
                            seq: 40,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 6
                            },
                            fieldProps: {
                                heading: "Name of the Abbot (laypeople please skip this section)",
                                onChange: (e) => {
                                    const current = form?.admission_student_address.find((x: any) => x.address_type === 'CURRENT_ADDRESS')
                                    const house = form?.admission_student_address.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')
                                    setForm({ ...form, admission_student_address: [{ ...house }, { ...current, name_of_abbot: e.target.value }] })
                                },
                                value: form?.admission_student_address?.find((x: any) => x.address_type === 'CURRENT_ADDRESS')?.name_of_abbot
                            }
                        },
                        {
                            seq: 41,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "House No.",
                                onChange: (e) => {
                                    const current = form?.admission_student_address.find((x: any) => x.address_type === 'CURRENT_ADDRESS')
                                    const house = form?.admission_student_address.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')
                                    setForm({ ...form, admission_student_address: [{ ...house }, { ...current, house_no: e.target.value }] })
                                },
                                value: form?.admission_student_address?.find((x: any) => x.address_type === 'CURRENT_ADDRESS')?.house_no
                            }
                        },
                        {
                            seq: 42,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Street / Road",
                                onChange: (e) => {
                                    const current = form?.admission_student_address.find((x: any) => x.address_type === 'CURRENT_ADDRESS')
                                    const house = form?.admission_student_address.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')
                                    setForm({ ...form, admission_student_address: [{ ...house }, { ...current, street: e.target.value }] })
                                },
                                value: form?.admission_student_address?.find((x: any) => x.address_type === 'CURRENT_ADDRESS')?.street

                            }
                        },
                        {
                            seq: 43,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Village",
                                onChange: (e) => {
                                    const current = form?.admission_student_address.find((x: any) => x.address_type === 'CURRENT_ADDRESS')
                                    const house = form?.admission_student_address.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')
                                    setForm({ ...form, admission_student_address: [{ ...house }, { ...current, village: e.target.value }] })
                                },
                                value: form?.admission_student_address?.find((x: any) => x.address_type === 'CURRENT_ADDRESS')?.village
                            }
                        },
                        {
                            seq: 44,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Town / City",
                                onChange: (e) => {
                                    const current = form?.admission_student_address.find((x: any) => x.address_type === 'CURRENT_ADDRESS')
                                    const house = form?.admission_student_address.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')
                                    setForm({ ...form, admission_student_address: [{ ...house }, { ...current, town: e.target.value }] })
                                },
                                value: form?.admission_student_address?.find((x: any) => x.address_type === 'CURRENT_ADDRESS')?.town
                            }
                        },
                        // {
                        //     seq: 45,
                        //     type: "TEXT_FIELD",
                        //     gridProps: {
                        //         xs: 12,
                        //         md: 4
                        //     },
                        //     fieldProps: {
                        //         heading: "District",
                        //         onChange: (e) => { }
                        //     }
                        // },
                        // {
                        //     seq: 45,
                        //     type: "TEXT_FIELD",
                        //     gridProps: {
                        //         xs: 12,
                        //         md: 4
                        //     },
                        //     fieldProps: {
                        //         heading: "Province",
                        //         onChange: (e) => { }
                        //     }
                        // },
                        {
                            seq: 45,
                            // type: "AUTO-COMPLETE",
                            // gridProps: {
                            //     xs: 12,
                            //     md: 4
                            // },
                            // fieldProps: {
                            //     getOptionLabel: (op: any) => op?.province_name,
                            //     labelId: "select_position",
                            //     placeholder: "Province",
                            //     heading: "Province",
                            //     onChange: (_: any, value: any) => {

                            //         if (value) {
                            //             // setForm({ ...form, province: value?.province_name })
                            //             setForm({ ...form, admission_student_address: { ...form?.admission_student_address, province: value?.province_name, district: '' } })

                            //             handleGetDistrict(value?.id_province)

                            //         } else {
                            //             // setForm({ ...form, province: undefined })
                            //             setForm({ ...form, admission_student_address: { ...form?.admission_student_address, province: '', district: '' } })

                            //             setDistrictData([])
                            //         }
                            //     },
                            //     options: province_data || [],
                            //     value: province_data?.find((x) => x?.province_name === form?.admission_student_address?.province) || null
                            // }
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Province",
                                onChange: (e) => {
                                    const current = form?.admission_student_address.find((x: any) => x.address_type === 'CURRENT_ADDRESS')
                                    const house = form?.admission_student_address.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')
                                    setForm({ ...form, admission_student_address: [{ ...house }, { ...current, province: e.target.value }] })
                                },
                                value: form?.admission_student_address?.find((x: any) => x.address_type === 'CURRENT_ADDRESS')?.province
                            }
                        },
                        {
                            seq: 46,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "District",
                                onChange: (e) => {
                                    const current = form?.admission_student_address.find((x: any) => x.address_type === 'CURRENT_ADDRESS')
                                    const house = form?.admission_student_address.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')
                                    setForm({ ...form, admission_student_address: [{ ...house }, { ...current, district: e.target.value }] })
                                },
                                value: form?.admission_student_address?.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')?.district
                            }
                            // type: "AUTO-COMPLETE",
                            // gridProps: {
                            //     xs: 12,
                            //     md: 4
                            // },
                            // fieldProps: {
                            //     getOptionLabel: (op: any) => op?.district_name,
                            //     labelId: "select_position",
                            //     placeholder: "District",
                            //     heading: "District",
                            //     onChange: (_: any, value: any) => {

                            //         if (value) {
                            //             // setForm({ ...form, district: value?.district_name })
                            //             setForm({ ...form, admission_student_address: { ...form?.admission_student_address, district: value?.district_name, district_sub: '' } })

                            //             handleGetSubDistrict(value?.id_district)

                            //         } else {
                            //             // setForm({ ...form, district: undefined })
                            //             setForm({ ...form, admission_student_address: { ...form?.admission_student_address, district: '', district_sub: '' } })

                            //             setSubDistrictData([])
                            //         }
                            //     },
                            //     options: district_data || [],
                            //     value: district_data?.find((x) => x?.district_name === form?.admission_student_address?.district) || null,
                            //     inputValue: form?.admission_student_address?.district || '',
                            // }
                        },
                        {
                            seq: 47,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "State",
                                onChange: (e) => {
                                    const current = form?.admission_student_address.find((x: any) => x.address_type === 'CURRENT_ADDRESS')
                                    const house = form?.admission_student_address.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')
                                    setForm({ ...form, admission_student_address: [{ ...house }, { ...current, district_sub: e.target.value }] })
                                },
                                value: form?.admission_student_address?.find((x: any) => x.address_type === 'CURRENT_ADDRESS')?.district_sub
                            }
                            // type: "AUTO-COMPLETE",
                            // gridProps: {
                            //     xs: 12,
                            //     md: 4
                            // },
                            // fieldProps: {
                            //     getOptionLabel: (op: any) => op?.district_sub_name,
                            //     labelId: "select_position",
                            //     placeholder: "State",
                            //     heading: "State",
                            //     onChange: (_: any, value: any) => {

                            //         if (value) {
                            //             console.log(value);
                            //             // setForm({ ...form, district_sub: value?.sub_district_name })
                            //             setForm({ ...form, admission_student_address: { ...form?.admission_student_address, district_sub: value?.district_sub_name } })


                            //         } else {
                            //             // setForm({ ...form, district_sub: undefined })
                            //             setForm({ ...form, admission_student_address: { ...form?.admission_student_address, district_sub: '' } })

                            //         }
                            //     },
                            //     options: sub_district_data || [],
                            //     value: sub_district_data?.find((x) => x?.sub_district_name === form?.admission_student_address?.district_sub) || null,
                            //     inputValue: form?.admission_student_address?.district_sub || '',

                            // }
                        },
                        // {
                        //     seq: 47,
                        //     type: "TEXT_FIELD",
                        //     gridProps: {
                        //         xs: 12,
                        //         md: 4
                        //     },
                        //     fieldProps: {
                        //         heading: "State",
                        //          onChange: (e) => {
                        //             setForm({ ...form, admission_student_address: { ...form?.admission_student_address, first_name: e.target.value } })
                        //         },
                        //         value: form?.admission_student_address?.first_name
                        //     }
                        // },
                        {
                            seq: 48,
                            type: "AUTO-COMPLETE",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                getOptionLabel: (op: any) => op?.country_name,
                                labelId: "select_position",
                                placeholder: "Country",
                                heading: "Country",
                                onChange: (_: any, value: any) => {
                                    const current = form?.admission_student_address.find((x: any) => x.address_type === 'CURRENT_ADDRESS')
                                    const house = form?.admission_student_address.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')
                                    if (value) {
                                        // setForm({ ...form, district_sub: value?.sub_district_name })

                                        setForm({ ...form, admission_student_address: [{ ...house }, { ...current, country: value?.country_name }] })
                                        // setForm({ ...form, admission_student_address: { ...form?.admission_student_address, country: value?.country_name } })


                                    } else {
                                        // setForm({ ...form, district_sub: undefined })
                                        setForm({ ...form, admission_student_address: [{ ...house }, { ...current, country: '' }] })

                                        // setForm({ ...form, admission_student_address: { ...form?.admission_student_address, country: '' } })

                                    }
                                },
                                options: country_data || [],
                                value: country_data?.find((x) => x?.country_name === form?.admission_student_address?.find((x: any) => x.address_type === 'CURRENT_ADDRESS')?.country) || null,
                                inputValue: form?.admission_student_address?.find((x: any) => x.address_type === 'CURRENT_ADDRESS')?.country || '',

                            }
                        },
                        // {
                        //     seq: 48,
                        //     type: "TEXT_FIELD",
                        //     gridProps: {
                        //         xs: 12,
                        //         md: 4
                        //     },
                        //     fieldProps: {
                        //         heading: "Country",
                        //         onChange: (e) => {
                        //             setForm({ ...form, admission_student_address: { ...form?.admission_student_address, country: e.target.value } })
                        //         },
                        //         value: form?.admission_student_address?.country
                        //     }
                        // },
                        {
                            seq: 49,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Postal/Zip Code",
                                onChange: (e) => {
                                    const current = form?.admission_student_address.find((x: any) => x.address_type === 'CURRENT_ADDRESS')
                                    const house = form?.admission_student_address.find((x: any) => x.address_type === 'HOUSE_REGISTRATION_ADDRESS')
                                    setForm({ ...form, admission_student_address: [{ ...house }, { ...current, postcode: e.target.value }] })
                                },
                                value: form?.admission_student_address?.find((x: any) => x.address_type === 'CURRENT_ADDRESS')?.postcode,
                                onkeypress: handleTypingNumber
                            }
                        },
                    ]} />

        </>

    )
}
const AdmissionStudentParent = (props: any) => {
    const { form, setForm } = props
    // const [province_data, setProVinceData] = useState<any[]>([]);
    // const [district_data, setDistrictData] = useState<any[]>([]);
    // const [sub_district_data, setSubDistrictData] = useState<any[]>([]);

    // const handleGetProvince = async () => {
    //     await ProvinceAPI.GetProvince().then(res => {
    //         if (res.status < 300) {
    //             setProVinceData(res.data?.data || [])
    //         } else {
    //             setProVinceData([]);
    //         }
    //     }).catch((error) => console.log(error))
    // }
    // const handleGetDistrict = async (id?: any) => {
    //     if (id) {
    //         await DistrictApi.getDistrictByProvince(id).then(res => {
    //             if (res.status < 300) {
    //                 setDistrictData(res.data?.data || [])
    //             } else {
    //                 setDistrictData([]);
    //             }
    //         }).catch((error) => console.log(error))
    //     } else {
    //         // await DistrictApi.getAllDistrict().then(res => {
    //         //     if (res.status < 300) {
    //         //         setDistrictData(res.data?.data || [])
    //         //     } else {
    //         //         setDistrictData([]);
    //         //     }
    //         // }).catch((error) => console.log(error))
    //     }

    // }
    // const handleGetSubDistrict = async (id?: any) => {
    //     if (id) {
    //         await SubDistrictApi.getSubDistrictByDistrict(id).then(res => {
    //             if (res.status < 300) {
    //                 setSubDistrictData(res.data?.data || [])
    //             } else {
    //                 setSubDistrictData([]);
    //             }
    //         }).catch((error) => console.log(error))
    //     } else {
    //         // await SubDistrictApi.getAllSubDistrict().then(res => {
    //         //     if (res.status < 300) {
    //         //         setSubDistrictData(res.data?.data || [])
    //         //     } else {
    //         //         setSubDistrictData([]);
    //         //     }
    //         // }).catch((error) => console.log(error))
    //     }

    // }


    // useEffect(() => {
    //     handleGetProvince()
    //     handleGetDistrict()
    //     handleGetSubDistrict()

    // }, [])
    const [country_data, setCountryData] = useState<any[]>([]);

    const handleGetCountry = async () => {
        let query: any = {
            page: 1,
            limit: 10000
        }
        await CountryApi.list(query).then(res => {
            if (res.status < 300) {
                setCountryData(res.data?.data.items || [])
            } else {
                setCountryData([]);
            }
        }).catch((error) => console.log(error))
    }



    useEffect(() => {

        handleGetCountry()
    }, [])
    return (
        <>
            <Typography variant='h4'>Parent</Typography>
            <StateComponents
                otherProps={{ spacing: 2 }}
                sxContainer={{ marginTop: '10px' }}
                typeProps={
                    [
                        {
                            seq: 51,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                heading: "Father's name",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, father_name: e.target.value } })
                                },
                                value: form?.admission_student_parent?.father_name,
                            }
                        },
                        {
                            seq: 52,
                            type: "SELECT",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                labelId: "ss",
                                heading: "Father's status",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, father_status: e.target.value } })
                                },
                                options: [
                                    {
                                        label: "Alived",
                                        value: 'ALIVED',
                                    },
                                    {
                                        label: "Died",
                                        value: 'DIED  ',
                                    },

                                ],
                                selectId: "",
                                value: form?.admission_student_parent?.father_status,

                            }
                        },
                        {
                            seq: 53,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                heading: "Father's occupation",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, father_occupation: e.target.value } })
                                },
                                value: form?.admission_student_parent?.father_occupation,
                            }
                        },
                        {
                            seq: 54,
                            type: "SELECT",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                labelId: "ss",
                                heading: "Father's income per year",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, father_income: e.target.value } })
                                },
                                options: [
                                    {
                                        label: "0-50k (THB)",
                                        value: '0-50k (THB)',
                                    },
                                    {
                                        label: "50k-100k (THB)",
                                        value: '50k-100k (THB)',
                                    },
                                    {
                                        label: "100k Up (THB)",
                                        value: '100k Up (THB)',
                                    },

                                ],
                                selectId: "",
                                value: form?.admission_student_parent?.father_income,
                            }
                        },
                        {
                            seq: 55,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                heading: "Mother's name",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, mother_name: e.target.value } })
                                },
                                value: form?.admission_student_parent?.mother_name,
                            }
                        },
                        {
                            seq: 56,
                            type: "SELECT",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                labelId: "ss",
                                heading: "Mother's status",
                                onChange: (e) => {
                                    // handleChange('form_type', index, e.target.value);
                                    setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, mother_status: e.target.value } })
                                },
                                options: [
                                    {
                                        label: "Alived",
                                        value: 'ALIVED',
                                    },
                                    {
                                        label: "Died",
                                        value: 'DIED  ',
                                    },

                                ],
                                selectId: "",
                                value: form?.admission_student_parent?.mother_status,

                            }
                        },
                        {
                            seq: 57,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                heading: "Mother's occupation",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, mother_occupation: e.target.value } })
                                },
                                value: form?.admission_student_parent?.mother_occupation,
                            }
                        },
                        {
                            seq: 58,
                            type: "SELECT",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                labelId: "ss",
                                heading: "Mother's income per year",
                                onChange: (e) => {
                                    // handleChange('form_type', index, e.target.value);
                                    setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, mother_income: e.target.value } })

                                },
                                options: [
                                    {
                                        label: "0-50k (THB)",
                                        value: '0-50k (THB)',
                                    },
                                    {
                                        label: "50k-100k (THB)",
                                        value: '50k-100k (THB)',
                                    },
                                    {
                                        label: "100k Up (THB)",
                                        value: '100k Up (THB)',
                                    },

                                ],
                                selectId: "",
                                value: form?.admission_student_parent?.mother_income,
                            }
                        },
                        {
                            seq: 59,
                            type: "SELECT",
                            gridProps: {
                                xs: 12,
                            },
                            fieldProps: {
                                labelId: "ss",
                                heading: "Parent's marriage status",
                                onChange: (e) => {
                                    // handleChange('form_type', index, e.target.value);
                                    setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, parent_marriage: e.target.value } })

                                },
                                options: [
                                    {
                                        label: "stay together",
                                        value: 'STAY_TOGETHER',
                                    },
                                    {
                                        label: "Divorce",
                                        value: 'DIVORCE',
                                    },

                                ],
                                selectId: "",
                                value: form?.admission_student_parent?.parent_marriage,
                            }
                        },
                        {
                            seq: 60,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                heading: "Referent person's name",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_name: e.target.value } })
                                },
                                value: form?.admission_student_parent?.refperson_name,
                            }
                        },
                        // {
                        //     seq: 61,
                        //     type: "TEXT_FIELD",
                        //     gridProps: {
                        //         xs: 12,
                        //         md: 3
                        //     },
                        //     fieldProps: {
                        //         heading: "Relationship",
                        //         onChange: (e) => {
                        //             setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_relationship: e.target.value } })
                        //         },
                        //         value: form?.admission_student_parent?.refperson_relationship,
                        //     }
                        // },
                        {
                            seq: 61,
                            type: "SELECT",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                labelId: "ss",
                                heading: "Relationship",
                                onChange: (e) => {
                                    // handleChange('form_type', index, e.target.value);
                                    setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_relationship: e.target.value } })

                                },
                                options: [
                                    {
                                        label: "Father",
                                        value: 'FATHER',
                                    },
                                    {
                                        label: "Mother",
                                        value: 'MOTHER',
                                    },
                                    {
                                        label: "Other",
                                        value: 'OTHER ',
                                    },

                                ],
                                selectId: "",
                                value: form?.admission_student_parent?.refperson_relationship,
                            }
                        },
                        {
                            seq: 62,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                heading: "Referent person's occupation",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_occupation: e.target.value } })
                                },
                                value: form?.admission_student_parent?.refperson_occupation,
                            }
                        },

                        {
                            seq: 63,
                            type: "SELECT",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                labelId: "ss",
                                heading: "Referent person's income per year",
                                onChange: (e) => {
                                    // handleChange('form_type', index, e.target.value);
                                    setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_income: e.target.value } })

                                },
                                options: [
                                    {
                                        label: "0-50k (THB)",
                                        value: '0-50k (THB)',
                                    },
                                    {
                                        label: "50k-100k (THB)",
                                        value: '50k-100k (THB)',
                                    },
                                    {
                                        label: "100k Up (THB)",
                                        value: '100k Up (THB)',
                                    },

                                ],
                                selectId: "",
                                value: form?.admission_student_parent?.refperson_income,
                            }
                        },
                        {
                            seq: 64,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                heading: "House No.",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_house: e.target.value } })
                                },
                                value: form?.admission_student_parent?.refperson_house,
                            }
                        },
                        {
                            seq: 65,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                heading: "Street / Road",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_street: e.target.value } })
                                },
                                value: form?.admission_student_parent?.refperson_street,
                            }
                        },
                        {
                            seq: 66,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                heading: "Village",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_vilage: e.target.value } })
                                },
                                value: form?.admission_student_parent?.refperson_vilage,
                            }
                        },
                        {
                            seq: 67,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                heading: "Town / City",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_town: e.target.value } })
                                },
                                value: form?.admission_student_parent?.refperson_town,
                            }
                        },
                        // {
                        //     seq: 68,
                        //     type: "TEXT_FIELD",
                        //     gridProps: {
                        //         xs: 12,
                        //         md: 3
                        //     },
                        //     fieldProps: {
                        //         heading: "District",
                        //         onChange: (e) => { }
                        //     }
                        // },
                        // {
                        //     seq: 69,
                        //     type: "TEXT_FIELD",
                        //     gridProps: {
                        //         xs: 12,
                        //         md: 3
                        //     },
                        //     fieldProps: {
                        //         heading: "Province",
                        //         onChange: (e) => { }
                        //     }
                        // },
                        // {
                        //     seq: 70,
                        //     type: "TEXT_FIELD",
                        //     gridProps: {
                        //         xs: 12,
                        //         md: 3
                        //     },
                        //     fieldProps: {
                        //         heading: "State",
                        //         onChange: (e) => { }
                        //     }
                        // },
                        {
                            seq: 68,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                heading: "Province",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_province: e.target.value } })

                                },
                                value: form?.admission_student_parent?.refperson_province
                            }
                        },
                        // {
                        //     seq: 68,
                        //     type: "AUTO-COMPLETE",
                        //     gridProps: {
                        //         xs: 12,
                        //         md: 3
                        //     },
                        //     fieldProps: {
                        //         getOptionLabel: (op: any) => op?.province_name,
                        //         labelId: "select_position",
                        //         placeholder: "Province",
                        //         heading: "Province",
                        //         onChange: (_: any, value: any) => {

                        //             if (value) {
                        //                 // setForm({ ...form, province: value?.province_name })
                        //                 setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_province: value?.province_name, refperson_district: '' } })

                        //                 handleGetDistrict(value?.id_province)

                        //             } else {
                        //                 // setForm({ ...form, province: undefined })
                        //                 setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_province: '', refperson_district: '' } })

                        //                 setDistrictData([])
                        //             }
                        //         },
                        //         options: province_data || [],
                        //         value: province_data?.find((x) => x?.province_name === form?.admission_student_parent?.refperson_province) || null,
                        //     }
                        // },
                        {
                            seq: 69,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                heading: "District",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_district: e.target.value } })

                                },
                                value: form?.admission_student_parent?.refperson_district
                            }
                        },
                        // {
                        //     seq: 69,
                        //     type: "AUTO-COMPLETE",
                        //     gridProps: {
                        //         xs: 12,
                        //         md: 3
                        //     },
                        //     fieldProps: {
                        //         getOptionLabel: (op: any) => op?.district_name,
                        //         labelId: "select_position",
                        //         placeholder: "District",
                        //         heading: "District",
                        //         onChange: (_: any, value: any) => {

                        //             if (value) {
                        //                 // setForm({ ...form, district: value?.district_name })
                        //                 setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_district: value?.district_name, refperson_district_sub: '' } })

                        //                 handleGetSubDistrict(value?.id_district)

                        //             } else {
                        //                 // setForm({ ...form, district: undefined })
                        //                 setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_district: '', refperson_district_sub: '' } })

                        //                 setSubDistrictData([])
                        //             }
                        //         },
                        //         options: district_data || [],
                        //         value: district_data?.find((x) => x?.district_name === form?.admission_student_parent?.refperson_district) || null,
                        //         inputValue: form?.admission_student_parent?.refperson_district || ''
                        //     }
                        // },
                        {
                            seq: 70,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                heading: "State",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_district_sub: e.target.value } })

                                },
                                value: form?.admission_student_parent?.refperson_district_sub
                            }
                        },
                        // {
                        //     seq: 70,
                        //     type: "AUTO-COMPLETE",
                        //     gridProps: {
                        //         xs: 12,
                        //         md: 3
                        //     },
                        //     fieldProps: {
                        //         getOptionLabel: (op: any) => op?.district_sub_name,
                        //         labelId: "select_position",
                        //         placeholder: "State",
                        //         heading: "State",
                        //         onChange: (_: any, value: any) => {

                        //             if (value) {
                        //                 // setForm({ ...form, district_sub: value?.sub_district_name })
                        //                 setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_district_sub: value?.district_sub_name } })


                        //             } else {
                        //                 // setForm({ ...form, district_sub: undefined })
                        //                 setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_district_sub: '' } })

                        //             }
                        //         },
                        //         options: sub_district_data || [],
                        //         value: sub_district_data?.find((x) => x?.sub_district_name === form?.admission_student_parent?.refperson_district_sub) || null,
                        //         inputValue: form?.admission_student_parent?.refperson_district_sub || ''
                        //     }
                        // },
                        // {
                        //     seq: 71,
                        //     type: "TEXT_FIELD",
                        //     gridProps: {
                        //         xs: 12,
                        //         md: 3
                        //     },
                        //     fieldProps: {
                        //         heading: "Country",
                        //         onChange: (e) => {
                        //             setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_country: e.target.value } })
                        //         },
                        //         value: form?.admission_student_parent?.refperson_country,
                        //     }
                        // },
                        {
                            seq: 71,
                            type: "AUTO-COMPLETE",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                getOptionLabel: (op: any) => op?.country_name,
                                labelId: "select_position",
                                placeholder: "Country",
                                heading: "Country",
                                onChange: (_: any, value: any) => {

                                    if (value) {
                                        // setForm({ ...form, district_sub: value?.sub_district_name })

                                        setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_country: value?.country_name } })
                                        // setForm({ ...form, admission_student_address: { ...form?.admission_student_address, country: value?.country_name } })


                                    } else {
                                        // setForm({ ...form, district_sub: undefined })
                                        setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_country: '' } })

                                        // setForm({ ...form, admission_student_address: { ...form?.admission_student_address, country: '' } })

                                    }
                                },
                                options: country_data || [],
                                value: country_data?.find((x) => x?.country_name === form?.admission_student_parent?.refperson_country) || null,
                                inputValue: form?.admission_student_parent?.refperson_country || '',

                            }
                        },
                        {
                            seq: 72,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Postal/Zip Code",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_postcode: e.target.value } })
                                },
                                value: form?.admission_student_parent?.refperson_postcode,
                                onkeypress: handleTypingNumber
                            }
                        },
                        {
                            seq: 73,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "Phone No.",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_phone: e.target.value } })
                                },
                                value: form?.admission_student_parent?.refperson_phone,
                                onkeypress: handleTypingNumber
                            }
                        },
                        {
                            seq: 74,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 4
                            },
                            fieldProps: {
                                heading: "E-mail",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student_parent: { ...form?.admission_student_parent, refperson_email: e.target.value } })
                                },
                                value: form?.admission_student_parent?.refperson_email,
                            }
                        },

                    ]} />
        </>

    )
}
const Documents = (props: any) => {
    const { form, setForm } = props
    const [documents, setDocuments] = useState<any[]>([])
    const getDocuments = async () => {
        let query: any = {
            page: 1,
            limit: 100,
            document_type: 'REGISTER_ADMISSION'
        }
        await DocumentsApi.list(query).then((res) => {
            if (res.status < 300) {

                setDocuments(res.data.data?.items || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    useEffect(() => {
        getDocuments()
    }, [])
    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: "center" }}>
                <Typography variant='h4'>Please upload your documents</Typography>
            </Box>
            <Box sx={{ marginTop: '10px' }}>
                <Typography>
                    Please upload your documents in the last session of the form and rename the file as your name follows with the type of the documents:
                </Typography>
                <Typography sx={{ marginTop: '10px' }}>
                    - Official Photo (size 1.5 inches)
                </Typography>
                <Typography>
                    - Passport(for foreigner) / ID card(for Thai)
                </Typography>
                <Typography>
                    - Transcript & Certificate
                </Typography>
                <Typography>
                    - Medical certificate
                </Typography>
                <Typography>
                    - House Registration(For Thai)
                </Typography>
                <Typography>
                    - Monk's identification card (for Thai)
                </Typography>
                <Typography>
                    - Certificate of Dhamma Studies
                </Typography>
                <Typography>
                    - Certificate of Personal Name Change
                </Typography>
                <Typography sx={{ marginTop: '10px' }}>
                    Please translate the Transcript and the Certificate of Graduation into English and attach with the original files (certified by the Legitimate Translation Institute).
                </Typography>

            </Box>
            <Box sx={{
                border: '1px solid #DDE1EB',
                borderRadius: '18px', overflow: 'hidden',
                marginTop: '20px'
            }}>
                <Box sx={{ background: '#4A4A4A', padding: '10px', display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography sx={{ fontWeight: "600", color: '#fff' }}>File</Typography>
                    {/* <ContainerButton
                        justifyContent='flex-end'
                        buttonData={[
                            {
                                buttonProps: {
                                    onClick: () => { }
                                },
                                key: "DOWNLOAD_CSV",
                                label: 'ดาวน์โหลดทั้งหมด',
                                seq: 1,
                                type: "DOWNLOAD_CSV"
                            }
                        ]}
                    /> */}
                </Box>
                <Box sx={{ padding: '10px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {documents?.map((item: any, index: number) => {
                        return (
                            <UploadFile item={item} form={form} setForm={setForm} />
                        )
                    })}
                </Box>
            </Box>
        </>
    )
}
const AdmissionStudentRegisterPayment = (props: any) => {
    const { form, setForm } = props
    const fileRef = useRef<any>()
    const { id } = useParams()
    const [type, setType] = useState<string>('THB')
    const [pathUrl, setPathUrl] = useState<string>("");
    useEffect(() => {
        const init = async () => {
            const response = await fetch("/resources/config.json");
            const results = await response.json();
            setPathUrl(results?.REACT_APP_BASE_API_PUBLIC || "");
        };
        init();
    }, []);
    const onImageChange = async (event: any) => {
        if (event.target.files && event.target.files[0]) {
            const formData = new FormData();

            //DRAFT
            formData.append('file', event.target.files[0]);
            formData.append('id_admission_student', `${id}`);
            formData.append('payment_catalog', 'REGISTER');

            await AdmissionFrontApi.register_payment_file(formData).then((res: any) => {
                if (res.status < 300) {
                    setForm({ ...form, admission_student_register_payment: { ...form?.admission_student_register_payment, id_admission_student_register_payment: res.data.data?.id_admission_student_register_payment, payment_file: res.data.data } })
                    if (fileRef.current) {
                        fileRef.current.value = null;
                    }
                    // swalSuccess('ยืนยันการชำระเงิน', 'ยืนยันการชำระเงิน เรียบร้อยแล้ว กรูณารอทางเจ้าหน้าที่ตรวจสอบ')
                }
            }).catch((error: any) => {
                console.log(error)
                if (fileRef.current) {
                    fileRef.current.value = null;
                }
                swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            })

        }
    }
    console.log(form);
    return (
        <>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={7}>
                        <Box sx={{
                            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                            padding: "40px",
                            borderRadius: "20px",
                            display: "flex",
                            flexDirection: 'column',
                            gap: '10px'
                        }}>
                            <Box sx={{
                                border: '2px solid #4A4A4A',
                                borderRadius: '18px', overflow: 'hidden',
                            }}>
                                <Box sx={{ background: '#4A4A4A', padding: '10px', display: "flex", justifyContent: 'center', alignItems: 'center' }}>
                                    <Typography sx={{ fontWeight: "600", color: '#fff' }}>please mack a payment through bank transfer as below:</Typography>

                                </Box>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6} sx={{display:'flex', alignItems:"center", height: "315px",}}>
                                        {form?.faculty?.payment_channels_register?.payment_channels_file ?
                                            <img src={pathUrl + '/' + form?.faculty?.payment_channels_register?.payment_channels_file?.file_path + form?.faculty?.payment_channels_register?.payment_channels_file?.file_name} style={{ width: '100%', maxHeight: '280px', objectFit: 'contain' }} /> :
                                            <>
                                                {/* <ButtonContained buttonName='Choose Image' onClick={() => fileRef.current.click()} /> */}
                                            </>
                                        }
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px', padding: '60px 20px' }}>
                                            {/* <Box sx={{ display: 'flex', gap: '10px' }}>
                                                <Typography sx={{ color: "#737373" }}>ชื่อบัญชี </Typography>
                                                <Typography sx={{ color: "#000" }}>{form?.faculty?.payment_channels_register?.account_name_th}</Typography>

                                            </Box> */}
                                            <Box sx={{ display: 'flex', gap: '10px', justifyContent:'space-between' }}>
                                                <Typography sx={{ color: "#737373" }}>Account Name </Typography>
                                                <Typography sx={{ color: "#000" }}>{form?.faculty?.payment_channels_register?.account_name_eng}</Typography>

                                            </Box>
                                            <Box sx={{ display: 'flex', gap: '10px', justifyContent:'space-between' }}>
                                                <Typography sx={{ color: "#737373" }}>Account No. </Typography>
                                                <Typography sx={{ color: "#000" }}>{form?.faculty?.payment_channels_register?.account_no}</Typography>
                                            </Box>
                                            {/* <Typography sx={{ color: "#737373" }}>Account No.</Typography> */}

                                            <Box sx={{ display: 'flex', gap: '10px', justifyContent:'space-between' }}>
                                                <Typography sx={{ color: "#737373" }}>Account Type </Typography>
                                                <Typography sx={{ color: "#000" }}>{form?.faculty?.payment_channels_register?.account_type}</Typography>

                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={{ background: '#4A4A4A', padding: '10px', display: 'flex', alignItems: 'center', gap: "10px", borderRadius: '18px' }}>
                                <Typography sx={{ color: '#fff' }}>Currency</Typography>
                                <StateComponents
                                    otherProps={{ spacing: 2 }}
                                    typeProps={[

                                        {
                                            seq: 1,
                                            type: "SELECT",
                                            gridProps: {
                                                xs: 12,
                                            },
                                            fieldProps: {
                                                labelId: "ss",
                                                // heading: "สกุลเงิน",
                                                onChange: (e) => {
                                                    setType(e.target.value)
                                                    // handleChange('form_type', index, e.target.value);
                                                },
                                                options: [
                                                    {
                                                        label: "THB",
                                                        value: 'THB',
                                                    },
                                                    {
                                                        label: "USD",
                                                        value: 'USD',
                                                    },
                                                ],
                                                selectId: "",
                                                value: type || ''
                                            }
                                        },


                                    ]} />
                                <Typography sx={{ color: '#fff' }}>Bachelor of arts degree : Application fee {type === 'THB' ? `${form?.course_of_study?.price_bath} Thai Baht (THB)` : `${form?.course_of_study?.price_usd} United States dollar (USD)`}</Typography>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <Box sx={{
                            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                            padding: "10px",
                            borderRadius: "20px",
                            height: "500px",
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: "center",
                            justifyContent: "center",
                            position: 'relative'
                        }} >
                            {form?.admission_student_register_payment?.payment_file ?
                                <img src={pathUrl + '/' + form?.admission_student_register_payment?.payment_file?.file_path + form?.admission_student_register_payment?.payment_file?.file_name} style={{ width: '100%', maxHeight: '450px', objectFit: 'contain' }} /> :
                                <>
                                    <ButtonContained buttonName='Choose Image' onClick={() => fileRef.current.click()} />
                                </>
                            }
                            <input ref={fileRef} className='hidden' type='file'
                                accept={"image/*"}
                                onChange={(e: any) => onImageChange(e)} />
                            {form?.admission_student_register_payment?.payment_file &&
                                <IconButton sx={{ position: "absolute", top: '20px', right: '20px' }} onClick={() => {
                                    setForm({ ...form, admission_student_register_payment: { ...form?.admission_student_register_payment, id_admission_student_register_payment: '', payment_file: undefined } })
                                }}><CancelIcon sx={{ color: "#e7e7e7" }} /></IconButton>}
                        </Box>
                    </Grid>
                </Grid>


                <StateComponents
                    otherProps={{ spacing: 2 }}
                    typeProps={[
                        {
                            seq: 1,
                            type: "DATE",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                onChange: (e) => {
                                    setForm({ ...form, admission_student_register_payment: { ...form?.admission_student_register_payment, payment_date: moment(e).format('YYYY-MM-DD') } })
                                },
                                heading: 'Payment Date',
                                placeholder: 'Payment Date',
                                allowClear: true,
                                onClear: () => {
                                    setForm({ ...form, admission_student_register_payment: { ...form?.admission_student_register_payment, payment_date: '' } })
                                },
                                value: form?.admission_student_register_payment?.payment_date
                            },
                        },
                        {
                            seq: 2,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                heading: "Payment Time",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student_register_payment: { ...form?.admission_student_register_payment, payment_date_time: e.target.value } })
                                },
                                value: form?.admission_student_register_payment?.payment_date_time || '',
                                type: 'time'
                            }
                        },
                        {
                            seq: 3,
                            type: "SELECT",
                            gridProps: {
                                xs: 12,
                                md: 1.5
                            },
                            fieldProps: {
                                labelId: "ss",
                                heading: "Currency",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student_register_payment: { ...form?.admission_student_register_payment, payment_currency: e.target.value } })

                                },
                                options: [
                                    {
                                        label: "THB",
                                        value: 'THB',
                                    },
                                    {
                                        label: "USD",
                                        value: 'USD',
                                    },

                                ],
                                selectId: "",
                                value: form?.admission_student_register_payment?.payment_currency,
                            }
                        },
                        {
                            seq: 4,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                heading: "Amount",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student_register_payment: { ...form?.admission_student_register_payment, payment_amount: e.target.value } })
                                },
                                value: form?.admission_student_register_payment?.payment_amount,
                                onkeypress: handleTypingNumber
                            }
                        },
                        {
                            seq: 5,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 1.5
                            },
                            fieldProps: {
                                heading: "Type",
                                onChange: (e) => {
                                    setForm({ ...form, admission_student_register_payment: { ...form?.admission_student_register_payment, payment_type: e.target.value } })
                                },
                                disabled: true,
                                value: form?.admission_student_register_payment?.payment_type || 'ATTACH_SLIP',
                            }
                        },
                    ]} />
            </Box>
        </>
    )
}

const UploadFile = (props: any) => {
    const { item, form, setForm } = props
    const fileRef = useRef<any>()
    const { id } = useParams()
    const [pathUrl, setPathUrl] = useState<string>("");
    useEffect(() => {
        const init = async () => {
            const response = await fetch("/resources/config.json");
            const results = await response.json();
            setPathUrl(results?.REACT_APP_BASE_API_PUBLIC || "");
        };
        init();
    }, []);
    const onImageChange = async (event: any) => {
        if (event.target.files && event.target.files[0]) {
            const formData = new FormData();

            //DRAFT
            formData.append('file', event.target.files[0]);
            formData.append('id_admission_student', `${id}`);

            await AdmissionFrontApi.student_file(formData).then((res: any) => {
                if (res.status < 300) {
                    setForm({ ...form, admission_student_file: form?.admission_student_file?.length > 0 ? [...form?.admission_student_file, { ...res.data.data, id_document: item?.id_document }] : [{ ...res.data.data, id_document: item?.id_document }] })
                    // console.log(res.data);
                    if (fileRef.current) {
                        fileRef.current.value = null;
                    }

                    // swalSuccess('ยืนยันการชำระเงิน', 'ยืนยันการชำระเงิน เรียบร้อยแล้ว กรูณารอทางเจ้าหน้าที่ตรวจสอบ')
                }
            }).catch((error: any) => {
                console.log(error)
                if (fileRef.current) {
                    fileRef.current.value = null;
                }
                swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            })

        }
    }
    function formatBytes(bytes: any, decimals = 2) {
        if (!+bytes) return '0 Bytes'

        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

        const i = Math.floor(Math.log(bytes) / Math.log(k))

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }
    return (
        <Box sx={{
            padding: '10px 15px', border: '1px solid #DDE1EB',
            borderRadius: '8px',
            display: "flex", justifyContent: 'space-between'
        }}>
            <Box sx={{ width: "100%" }}>
                <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
                    <AddBoxIcon sx={{ color: '#5FB95D', cursor: "pointer" }} onClick={() => fileRef.current.click()} />
                    <Typography sx={{ whiteSpace: "nowrap" }}>{item?.document_name}<span style={{ color: "red", marginLeft: '10px' }}>{item?.is_require === 1 ? '*' : ''}</span></Typography>
                </Box>
                {form?.admission_student_file?.find((x: any) => x?.id_document === item?.id_document) && <Typography>{form?.admission_student_file?.find((x: any) => x?.id_document === item?.id_document)?.file_name} {formatBytes(form?.admission_student_file?.find((x: any) => x?.id_document === item?.id_document)?.file_size)}</Typography>}
            </Box>
            {form?.admission_student_file?.find((x: any) => x?.id_document === item?.id_document) &&
                <OptionsButtonCustom
                    // enableEdit
                    enableView
                    enableDelete
                    onViewClick={() => { window.open(pathUrl + '/' + form?.admission_student_file?.find((x: any) => x?.id_document === item?.id_document)?.file_path + form?.admission_student_file?.find((x: any) => x?.id_document === item?.id_document)?.file_name, '_blank') }}
                    // onEditClick={() => navigate(routeName.admission.SetupCourseOpeningDetail)}
                    onDeleteClick={() => {
                        setForm({ ...form, admission_student_file: form?.admission_student_file?.filter((x: any) => x?.id_document !== item?.id_document) })
                    }}
                />
            }
            {/* <ContainerButton
                justifyContent='flex-end'
                buttonData={[
                    {
                        buttonProps: {
                            onClick: () => { fileRef.current.click() }
                        },
                        key: "IMPORT_EXCEL",
                        label: 'Upload',
                        seq: 1,
                        type: "IMPORT_EXCEL"
                    }
                ]}
            /> */}
            <input ref={fileRef} className='hidden' type='file'
                // accept={"image/*"} 
                onChange={(e: any) => onImageChange(e)} />
        </Box>
    )
}